import Vue from 'vue'

export default {

  accountInvitations (state, getters) {
    const { userAccount, invitations } = state
    if (!userAccount) {
      return []
    }
    return invitations.filter(invitation => invitation.account.id === userAccount['.key'])
  },
  userInvitations (state, getters) {
    const { user, invitations } = state
    if (!user) {
      return []
    }
    return invitations.filter(invitation => invitation.email === user.email)
  },
  accountDisplaySetups (state, getters) {
    const { accountDisplaySetups } = state
    if (!accountDisplaySetups) {
      // THE LOCAL STORAGE IS ONLY FOR DEVELOPMENT .. SHOULD BE REMOVED
      if (!state.userAccount) return {}
      const accountLocalStorage = Vue.$storage.get(state.userAccount['.key'], {})
      if (accountLocalStorage.hasOwnProperty('displaySetups')) {
        return accountLocalStorage.displaySetups
      }
      return {}
    }
    return accountDisplaySetups
  }
}
